import { render } from "./FontAwesomeIcon.vue?vue&type=template&id=5cd5718f&bindings={}"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js"
script.render = render

export default script